<template>
  <v-card-title
    v-bind="{...defaults, ...$attrs}"
    class="ol-card__title px-xs-only-2 pb-xs-only-0"
    v-on="$listeners"
  >
    <template
      v-for="(_, slot) of $scopedSlots"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
    <span class="ol-card__title-content"><slot /></span>
  </v-card-title>
</template>

<script>
export default {
  name: 'OlCardTitle',
  inheritAttrs: false,
  beforeCreate() {
    this.defaults = {

    }
  }
}
</script>

<style lang="scss">

  .ol-card__title-content {
    text-transform: none;
    font-weight: 500;
    color: var(--v-darkslategray-base);
    font-family: $heading-font-family;
  }

</style>
